import {SET_FILTER_DATA, CLEAR_FILTER_DATA} from "./actions";

export const initialFiltersState = {
  data: {},
  page: 1,
  size: 10
};

const filtersData = (state = initialFiltersState, action) => {
  switch (action.type) {
    case SET_FILTER_DATA:
      return action.payload
    case CLEAR_FILTER_DATA:
      return initialFiltersState
    default:
      return state;
  }
}

export default filtersData;
